/**
 * 통합 빠른 링크 (Quick Link) 컴포넌트 (반응형)
 * 화면에 고정되어 표시되는 서비스 바로가기 배너입니다.
 * 데스크톱: 우측 하단 고정
 * 모바일: 중앙 오른쪽 플로팅
 */

import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import bannerImg from '../assets/service.png';

const QuickContainer = styled.div`
  /* 데스크톱 기본 스타일 */
  position: fixed;
  z-index: 900;
  right: 2%;
  bottom: 12%;

  /* 1024px ~ 1350px: 숨김 */
  @media screen and (min-width: 1024px) and (max-width: 1350px) {
    display: none;
  }

  /* 모바일 스타일 (1023px 이하): 숨김 */
  @media (max-width: 1023px) {
    display: none;
  }
`;

const QuickMenu = styled.div`
  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      text-align: center;

      a {
        display: block;
      }

      img {
        /* 데스크톱 기본 */
        width: 160px;
        height: 149px;
        display: block;

        /* 큰 데스크톱 화면 */
        @media screen and (min-width: 1601px) {
          width: 170px;
          height: 158px;
        }

        @media screen and (min-width: 1801px) {
          width: 180px;
          height: 168px;
        }

        @media screen and (min-width: 2001px) {
          width: 190px;
          height: 177px;
        }
      }
    }
  }
`;

/**
 * Quick 컴포넌트
 * 오른쪽 하단에 고정되는 플로팅 배너
 */
function Quick() {
  // 현재 라우트 위치 정보
  const location = useLocation();

  // 배너 표시 여부 상태
  const [display, setDisplay] = useState(true);

  /**
   * 라우트 변경 시 배너의 표시 여부 조정
   * - 서비스 문의 페이지(/care/5): 숨김 (중복 방지)
   * - 기타 페이지: 하단에 표시
   */
  useEffect(() => {
    if (location.pathname === '/care/9') {
      // 서비스 문의 페이지: 배너 숨김 (페이지 내용과 중복)
      setDisplay(false);
    } else {
      setDisplay(true);
    }
  }, [location.pathname]);

  return (
    <QuickContainer>
      {/* 배너 표시 조건 */}
      {display && (
        <QuickMenu>
          <ul>
            <li>
              {/* 서비스 문의 페이지로 이동하는 배너 링크 */}
              <Link to="/care/8">
                <img src={bannerImg} alt="서비스 바로가기" />
              </Link>
            </li>
          </ul>
        </QuickMenu>
      )}
    </QuickContainer>
  );
}

export default Quick;
